import { createServerFn } from '@tanstack/react-start'
import { getFromS3, listFromS3, putToS3 } from '../../lib/s3'
import { createUserSchema } from './userSchemas'
import type { User } from './userSchemas'

export const createUser = createServerFn({ method: 'POST' })
  .inputValidator(createUserSchema)
  .handler(async (ctx): Promise<User[]> => {
    const { name, colour } = ctx.data
    const key = `users/${name}.json`

    await putToS3(key, { name, colour })

    const keys = await listFromS3('users/')
    const userKeys = keys.filter((k): k is string => !!k && k.endsWith('.json'))
    const users = await Promise.all(userKeys.map((k) => getFromS3(k) as Promise<User>))
    return users
  })
